import { action, observable } from 'mobx';
import { CmsServiceInterface, Faq, FaqProject, ProjectFaqItem } from 'services/cms/types';

interface Data {
  inputValue: string;
  faqData: Faq[];
  retailFaqs: Faq[];
  ledFaqs: Faq[];
  evcFaqs: Faq[];
  isOpen: Record<FaqProject, boolean>;
}

const initialState: Data = {
  inputValue: '',
  faqData: [],
  retailFaqs: [],
  ledFaqs: [],
  evcFaqs: [],
  isOpen: {
    [FaqProject.evc]: false,
    [FaqProject.led]: false,
    [FaqProject.retail]: false,
  },
};

const projectNames: Record<FaqProject, string> = {
  [FaqProject.retail]: 'Retail energy',
  [FaqProject.led]: 'LED Services',
  [FaqProject.evc]: 'Ev charging',
};

class FAQStore {
  data: Data = observable(initialState);

  constructor(private readonly cmsService: CmsServiceInterface) {}

  initState = action((initialState: Data): void => {
    this.data.faqData = initialState.faqData;
    this.splitFaqData();
  });

  searchFAQs = action(async (): Promise<void> => {
    this.data.faqData = await this.cmsService.getFAQs();
    this.splitFaqData();
  });

  setIsOpen = action((project: FaqProject, isOpen: boolean) => {
    this.data.isOpen = { ...this.data.isOpen, [project]: isOpen };
  });

  isOpen = (project: FaqProject): boolean => {
    return this.data.isOpen[project];
  };

  get inputValue(): string {
    return this.data.inputValue;
  }

  get faqData(): Faq[] {
    return this.data.faqData;
  }

  get retailFaqs(): Faq[] {
    return this.data.retailFaqs;
  }

  get ledFaqs(): Faq[] {
    return this.data.ledFaqs;
  }

  get evcFaqs(): Faq[] {
    return this.data.evcFaqs;
  }

  getProjectByQuestion = (question: string): FaqProject => {
    for (const data of this.faqData) {
      for (const item of data.items) {
        if (item.question === question) {
          return data.project;
        }
      }
    }
    return FaqProject.retail;
  };

  get faqTitles(): ProjectFaqItem[] {
    const { faqData } = this.data;
    const formattedFaqData: ProjectFaqItem[] = [];
    faqData.map((singleData) =>
      formattedFaqData.push(
        ...singleData.items.map((item) => ({
          ...item,
          project: projectNames[singleData.project],
        }))
      )
    );
    return formattedFaqData;
  }

  private splitFaqData = action(() => {
    this.data.retailFaqs = this.faqData.filter((item) => item.project === FaqProject.retail);
    this.data.ledFaqs = this.faqData.filter((item) => item.project === FaqProject.led);
    this.data.evcFaqs = this.faqData.filter((item) => item.project === FaqProject.evc);
  });

  changeInputValue = action((value: string) => {
    this.data.inputValue = value;
  });
}
export default FAQStore;
